<interview-wrapper [title]="interview?.title" [truncateTitle]="true">
    <div step-content class="flexbox flex-column align-items-center interview-screen-wrapper">
        <div class="alert error" *ngIf="rerecordAnswerMessage">
            {{rerecordAnswerMessage | translate}}
        </div>
        <div class="interview-header">
            <h2 class="title question-title" tabindex="-1">
                {{'interviews.Question' | translate}}
                {{'interviews.Current of Total' | translate: {current_row: questionIndex, total_rows: questionTotal} }}:
                {{currentItem?.question_text}}
            </h2>
            <p>{{'interviews.Time to respond' | translate: {minutes: duration} }}</p>
        </div>
        <div class="video-toggle">
            <div class="btn-group">
                <button type="button" class="btn"
                    [ngClass]="{
                        'btn_primary': showQuestion,
                        'btn_alt-default': !showQuestion,
                        'btn_disabled': !questionFinished && !showQuestion
                    }"
                    (click)="showQuestion = true">{{'interviews.Question' | translate}}</button>
                <button type="button" class="btn"
                    [ngClass]="{
                        'btn_primary': !showQuestion,
                        'btn_alt-default': showQuestion,
                        'btn_disabled': !recording && !questionFinished
                    }"
                    (click)="showQuestion = false">{{'interviews.Your Response' | translate}}</button>
            </div>
        </div>
        <div class="video-container">
            <div class="interview-video"
                [ngClass]="{'show': showQuestion}">
                <vg-player (onPlayerReady)="onPlayerReady($event)" [hidden]="answers">
                    <div *ngIf="startResponse && !questionFinished" class="video-overlay"></div>
                    <video [vgMedia]="playback" #playback id="singleVideo" class='question-video'
                           preload="none">
                        <source [src]="currentItem?.question_file" type="video/mp4">
                    </video>
                </vg-player>
            </div>
            <div class="response-container"
                [ngClass]="{'show': !showQuestion}">
                <div *ngIf="!recording && !questionFinished" class="video-overlay"></div>
                <video-stream></video-stream>
            </div>
        </div>
    </div>

    <div step-actions>
        <div class="timer-container" *ngIf="!questionFinished">
            <div class="timer-label">
                <span *ngIf="!recording">{{'interviews.Recording starts in' | translate}}</span>
                <span *ngIf="recording">{{'interviews.Recording' | translate}}</span>
            </div>
            <countdown #questiontimer
                class="question-timer"
                [config]="questionTimerConfig"
                (event)="onQuestionTimerEvent($event)"
                *ngIf="!recording"
            ></countdown>
            <countdown
                #responsetimer
                [config]="{ leftTime: maxCount, format:'m:ss', notify: 0, demand: true}"
                (event)="stopRecording($event)"
                *ngIf="showTimer && recording"
            ></countdown>

            <div class="progress-wrapper">
                <div class="progress">
                    <div class="progress-bar"
                        role="progressbar"
                        [ngClass]="timerColorClass"
                        attr.aria-valuenow="{{currentCount}}"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        [ngStyle]="{'width':((recording ? ((maxCount-currentCount)/maxCount) : ((questionTimerConfig.leftTime-currentCount)/questionTimerConfig.leftTime))*100) + '%' }">
                    </div>
                </div>
            </div>
        </div>
        <div>
            <button *ngIf="(!recording && !questionFinished) && !done"
                class="btn"
                [disabled]="!startResponse"
                [ngClass]="{'btn_primary' : startResponse, 'btn_disabled' : !startResponse}"
                (click)="startRecording()"
            >
                @if (!loading) {
                    {{'interviews.Record Answer' | translate}}
                } @else {
                    {{'interviews.Starting...' | translate}}
                }
            </button>
            <button *ngIf="recording"
                    #stopRecordingBtn
                    [disabled]="!enableStopRecording"
                    (click)="stopRecording();"
                    class="btn btn_danger">
                {{'interviews.Stop Recording' | translate}}
            </button>
            <button *ngIf="questionFinished && !done"
                    #nextQuestionBtn
                    (click)="loadNextQuestion()"
                    class="btn btn_primary">
                {{'interviews.Next Question' | translate}}
            </button>
        </div>
    </div>
</interview-wrapper>

